exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".events-heading[data-v-7296834e]{font-size:24px;font-weight:700;margin-bottom:16px}a[data-v-7296834e]{color:#0645ad;text-decoration:none}a[data-v-7296834e]:hover{text-decoration:underline}", ""]);

// exports
